// Auth0 config from build-time env. Required — every environment, including
// local dev, authenticates against the org's Auth0 tenant (use the dev
// tenant's credentials locally); there is no unauthenticated fallback. All
// values are public SPA config.

export const AUTH_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
export const AUTH_CLIENT_ID = process.env.REACT_APP_AUTH0_UI_CLIENTID;
export const AUTH_AUDIENCE = process.env.REACT_APP_AUTH0_API_AUDIENCE;
// Optional: the Azure AD (DFO) connection slug. When set, login goes straight to
// Microsoft. When unset, Auth0 universal login shows whatever the app enables —
// which should be only the DFO connection.
export const AUTH_CONNECTION = process.env.REACT_APP_AUTH0_CONNECTION;

const REQUIRED_AUTH_VARS = [
  'REACT_APP_AUTH0_DOMAIN',
  'REACT_APP_AUTH0_UI_CLIENTID',
  'REACT_APP_AUTH0_API_AUDIENCE',
];

export const missingAuthVars = REQUIRED_AUTH_VARS.filter((key) => !process.env[key]);

// Auth0 throws these error codes from getAccessTokenSilently when a token can't
// be renewed without user interaction (no SSO session, or a browser blocking the
// renewal iframe/refresh token). That's a "please sign in again" condition, not a
// data-fetch failure, so callers should redirect rather than show an error banner.
const SILENT_AUTH_ERROR_CODES = new Set([
  'login_required',
  'consent_required',
  'interaction_required',
]);

export function isSilentAuthError(err: unknown): boolean {
  return (
    typeof err === 'object' &&
    err !== null &&
    'error' in err &&
    SILENT_AUTH_ERROR_CODES.has(String((err as { error: unknown }).error))
  );
}
